import { useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getBrandingColorPalette } from '../../base/styles';

import { styleWeb } from './stylesWeb';

const _inlineStyles = {
    _s0: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '5'
    },
    _s1: {
        verticalAlign: 'text-top'
    }
};

declare var config: Object;

const colorWhite = {
    color: 'white'
};
type Props = {

    /**
     * Style props for footer.
     */
    style?: Object,

    /**
     * Changing the style based on prejoint styles.
     *
     */
    prejoin: ?boolean,
};

export const Footer = (props: Props) => {
    const { t } = useTranslation();
    const matched = useMediaQuery('(max-width:760px)');
    const { interfaceConfig } = useSelector(
        state => state['features/base/config']
    );

    const h3Style = {
        color: interfaceConfig?.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : 'white',
        fontSize: '12px'
    };

    React.useEffect(() => {
        if (
            interfaceConfig
            && interfaceConfig?.disablePrejoinFooter === true
            && !matched
        ) {
            const querySelcted = document.querySelector('#lobby-screen');

            if (querySelcted?.hasOwnProperty('style')) {
                querySelcted.style.minHeight = '850px';
            }
        }

        if (
            interfaceConfig
            && interfaceConfig?.disablePrejoinFooter === true
            && matched
        ) {
            const querySelcted = document.querySelector('#lobby-screen');

            if (querySelcted?.hasOwnProperty('style')) {
                querySelcted.style.minHeight = '995px';
            }
        }
    }, [ interfaceConfig, matched ]);

    if (props?.prejoin) {
        return (
            <React.Fragment>
                {config?.MEGAMENU_HEADER ? (
                    <footer
                        className = { `${
                            interfaceConfig?.disablePrejoinFooter === true
                            && !matched
                                ? 'headerFooter'
                                : ''
                        } footer-container pre-join-container` }
                        id = 'footer'
                        style = { props?.style }>
                        {props?.footer}
                        {interfaceConfig
                            && !interfaceConfig?.disablePrejoinFooter && (
                            <>
                                <div
                                    className = 'd-md-flex premeeting-container'>
                                    <div className = 'parent-copyright'>
                                        <div className = 'copyright'>
                                            <strong>
                                                <span>
                                                    &copy; {t('welcomepage.footer.copyright')} 2020 -{' '}
                                                    {new Date().getFullYear()}{' '}
                                                    {t('welcomepage.footer.meethourLLC')}.{' '}
                                                    {t('welcomepage.footer.allRightsReserved')}
                                                </span>
                                            </strong>
                                        </div>
                                    </div>
                                    <div
                                        className = 'social-links'
                                        style = { _inlineStyles._s0 }>
                                        <a
                                            href = 'https://www.facebook.com/meethour/'
                                            rel = 'noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-facebook' />
                                        </a>

                                        <a
                                            href = 'https://twitter.com/MeetHourApp/'
                                            rel = 'noreferrer'
                                            target = '_blank'>
                                            <svg
                                                height = '17'
                                                style = { _inlineStyles._s1 }
                                                viewBox = '0 0 512 512'
                                                width = '17'
                                                xmlns = 'http://www.w3.org/2000/svg'>
                                                <path
                                                    d = { 'M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8'
                                                        + 'L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48z'
                                                        + 'M364.4 421.8h39.1L151.1 88h-42L364.4 421.8z' }
                                                    fill = '#ffffff' /></svg>
                                        </a>

                                        <a
                                            href = 'https://www.instagram.com/MeetHourApp/'
                                            rel = 'noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-instagram' />
                                        </a>

                                        <a
                                            href = 'https://www.linkedin.com/company/meethour/'
                                            rel = 'noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-linkedin' />
                                        </a>

                                        <a
                                            href = 'https://www.youtube.com/channel/UCbB-py_vQt2lXJ1VMMVIH7w'
                                            rel = 'noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-youtube' />
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                        {interfaceConfig
                            && interfaceConfig?.disablePrejoinFooter && (
                            <div
                                className = 'container'
                                style = { styleWeb.disablePrejoinFooter }>
                                <h3 style = { h3Style }>
                                    {interfaceConfig.APP_NAME}
                                    {interfaceConfig.SHOW_POWERED_BY
                                            && <span>. Powered by Meet Hour</span>
                                    }
                                </h3>
                            </div>
                        )}
                    </footer>
                ) : (
                    <footer
                        className = {
                            interfaceConfig?.disablePrejoinFooter === true
                            && !matched
                                ? 'headerFooter'
                                : ''
                        }
                        id = 'footer'
                        style = { props?.style }>
                        {interfaceConfig
                            && !interfaceConfig?.disablePrejoinFooter && (
                            <>
                                <div className = 'footer-top'>
                                    <div className = 'container'>
                                        <div className = 'row'>
                                            <div className = 'col-lg-3 col-md-6 footer-contact'>
                                                <h3 style = { colorWhite }>
                                                    {t('welcomepage.footer.meethourLLC', { lng: 'en' })}
                                                    <span>.</span>
                                                </h3>
                                                <p>
                                                    {t('welcomepage.footer.officeAddress')}
                                                    <br />
                                                    <strong>
                                                        {t('welcomepage.footer.phone')}:
                                                    </strong>{' '}
                                                    <a href = 'tel:+13128009410'>
                                                        +1 (312) 800 9410
                                                    </a>
                                                    <br />
                                                    <strong>
                                                        {t('welcomepage.footer.email')}:
                                                    </strong>{' '}
                                                    <a href = 'mailto:hello@meethour.io'>
                                                        hello@meethour.io
                                                    </a>
                                                    <br />
                                                </p>
                                            </div>

                                            <div className = 'col-lg-2 col-md-6 footer-links'>
                                                <h4>{t('welcomepage.footer.company')}</h4>
                                                <ul>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/'>{t('welcomepage.footer.home')}</a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/who-we-are.html'>
                                                            {t('welcomepage.footer.whoAreYou')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/#features'>
                                                            {t('welcomepage.header.features')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/#pricing'>
                                                            {t('welcomepage.header.pricing')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />{' '}
                                                        <a
                                                            href = 'https://testimonials.meethour.io/all'

                                                            rel = 'noreferrer'
                                                            target = '_blank'>
                                                            {t('welcomepage.footer.testimonials')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/news.html'>
                                                            {t('welcomepage.footer.inTheNews')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/contact.html'>
                                                            {t('welcomepage.footer.contact')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/FAQ.html'>
                                                            {t('welcomepage.footer.faqs')}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className = 'col-lg-3 col-md-6 footer-links'>
                                                <h4>{t('welcomepage.footer.app')}</h4>
                                                <ul>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />{' '}
                                                        <a
                                                            href = 'https://apps.apple.com/in/app/meet-hour/id1527001689'
                                                            rel = 'noopener noreferrer'
                                                            target = '_blank'>
                                                            {t('welcomepage.footer.iOSAppDownload')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a
                                                            href = 'https://play.google.com/store/apps/details?id=go.meethour.io'
                                                            rel = 'noopener noreferrer'
                                                            target = '_blank'>
                                                            {t('welcomepage.footer.androidAppDownload')}
                                                        </a>
                                                    </li>

                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/disclaimer.html'>
                                                            {t('welcomepage.footer.disclaimer')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/privacy-policy.html'>
                                                            {t('welcomepage.footer.privacyPolicy')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/terms-conditions.html'>
                                                            {t('welcomepage.footer.termsConditions')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />
                                                        <a href = '/refund-and-cancellation.html'>
                                                            {t('welcomepage.footer.refundCancellationPolicy')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />{' '}
                                                        <a
                                                            href = 'https://docs.v-empower.com/docs/MeetHour-API '
                                                            rel = 'noreferrer'
                                                            target = {
                                                                '_blank'
                                                            }>
                                                            {t('welcomepage.footer.apiDocumentation')}
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <i className = 'bx bx-chevron-right' />{' '}
                                                        <a
                                                            href = 'https://github.com/v-empower/MeetHour-Web-MobileSDKs'
                                                            rel = 'noreferrer'
                                                            target = {
                                                                '_blank'
                                                            }>
                                                            {t('welcomepage.footer.webMobileSDK')}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className = 'col-lg-4 col-md-6 footer-newsletter'>
                                                <img
                                                    className = 'img-fluid'
                                                    src = 'images/footer-img.png' />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className = 'container d-md-flex py-4'>
                                    <div className = 'mr-md-auto text-center text-md-left'>
                                        <div className = 'copyright'>
                                            &copy; {t('welcomepage.footer.copyright')}{' '}
                                            <strong>
                                                <span>{t('welcomepage.footer.meethourLLC', { lng: 'en' })}.</span>
                                            </strong>
                                            . {t('welcomepage.footer.allRightsReserved')}
                                        </div>
                                    </div>
                                    <div className = 'social-links text-center text-md-right pt-3 pt-md-0'>
                                        <a
                                            href = 'https://www.facebook.com/meethour/'
                                            rel = 'noopener noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-facebook' />
                                        </a>
                                        <a
                                            href = 'https://twitter.com/MeetHourApp/'
                                            rel = 'noopener noreferrer'
                                            target = '_blank'>
                                            <svg
                                                height = '17'
                                                style = { _inlineStyles._s1 }
                                                viewBox = '0 0 512 512'
                                                width = '17'
                                                xmlns = 'http://www.w3.org/2000/svg'>
                                                <path
                                                    d = { 'M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8'
                                                        + 'L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48z'
                                                        + 'M364.4 421.8h39.1L151.1 88h-42L364.4 421.8z' }
                                                    fill = '#ffffff' /></svg>
                                        </a>
                                        <a
                                            href = 'https://www.instagram.com/MeetHourApp/'
                                            rel = 'noopener noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-instagram' />
                                        </a>
                                        <a
                                            href = 'https://www.linkedin.com/company/meethour/'
                                            rel = 'noopener noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-linkedin' />
                                        </a>
                                        <a
                                            href = ' https://www.youtube.com/channel/UCbB-py_vQt2lXJ1VMMVIH7w/'
                                            rel = 'noopener noreferrer'
                                            target = '_blank'>
                                            <i className = 'bx bxl-youtube' />
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                        {interfaceConfig
                            && interfaceConfig?.disablePrejoinFooter && (
                            <div
                                className = 'container'
                                style = { styleWeb.disablePrejoinFooter }>
                                <h3 style = { h3Style }>
                                    {interfaceConfig.APP_NAME}
                                    {interfaceConfig.SHOW_POWERED_BY
                                            && <span>. Powered by Meet Hour</span>
                                    }
                                </h3>
                            </div>
                        )}
                    </footer>
                )}
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {config?.MEGAMENU_HEADER ? (
                <footer
                    className = { `${
                        interfaceConfig?.disablePrejoinFooter === true
                        && !matched
                            ? 'headerFooter'
                            : ''
                    } footer-container` }
                    id = 'footer'
                    style = { props?.style }>
                    {interfaceConfig
                        && !interfaceConfig?.disablePrejoinFooter && (
                        <>

                            <div
                                className = 'container d-md-flex justify-content-center camera-permissions-copyright'>
                                <div className = 'copyright'>
                                    <strong>
                                        <span>
                                            &copy; {t('welcomepage.footer.copyrightText')}
                                        </span>
                                    </strong>
                                </div>
                            </div>
                        </>
                    )}
                    {interfaceConfig
                        && interfaceConfig?.disablePrejoinFooter && (
                        <div
                            className = 'container'
                            style = { styleWeb.disablePrejoinFooter }>
                            <h3 style = { h3Style }>
                                {interfaceConfig.APP_NAME}
                                {interfaceConfig.SHOW_POWERED_BY
                                        && <span>. Powered by Meet Hour</span>
                                }
                            </h3>
                        </div>
                    )}
                </footer>
            ) : (
                <footer
                    className = {
                        interfaceConfig?.disablePrejoinFooter === true
                        && !matched
                            ? 'headerFooter'
                            : ''
                    }
                    id = 'footer'
                    style = { props?.style }>
                    {interfaceConfig
                        && !interfaceConfig?.disablePrejoinFooter && (
                        <>
                            <div className = 'footer-top'>
                                <div className = 'container'>
                                    <div className = 'row'>
                                        <div className = 'col-lg-3 col-md-6  footer-contact'>
                                            <h3 style = { colorWhite }>
                                                {t('welcomepage.footer.meethourLLC', { lng: 'en' })}<span>.</span>
                                            </h3>
                                            <p>
                                                {t('welcomepage.footer.androidAppDofficeAddressownload')}
                                                <br />
                                                <br />
                                                <br />
                                                <strong>{t('welcomepage.footer.phone')}:</strong>
                                                <a href = 'tel:+13128009410'>
                                                    +1 (312) 800 9410
                                                </a>
                                                <br />
                                                <strong>{t('welcomepage.footer.email')}:</strong>
                                                <a href = 'mailto:hello@meethour.io'>
                                                    hello@meethour.io
                                                </a>
                                                <br />
                                            </p>
                                        </div>

                                        <div className = 'col-lg-2 col-md-6  footer-links'>
                                            <h4> {t('welcomepage.footer.company')}</h4>
                                            <ul>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/who-we-are.html'>
                                                        {t('welcomepage.footer.whoAreYou')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '#features'>
                                                        {t('welcomepage.header.features')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '#pricing'>
                                                        {t('welcomepage.header.pricing')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />{' '}
                                                    <a
                                                        href = 'https://testimonials.meethour.io/all'

                                                        rel = 'noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.footer.testimonials')}
                                                    </a>
                                                </li>

                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/news.html'>
                                                        {t('welcomepage.footer.inTheNews')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/contact.html'>
                                                        {t('welcomepage.footer.contact')}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className = 'col-lg-3 col-md-6 footer-links'>
                                            <h4> {t('welcomepage.footer.app')}</h4>
                                            <ul>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />{' '}
                                                    <a
                                                        href = 'https://apps.apple.com/in/app/meet-hour/id1527001689'
                                                        rel = 'noopener noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.footer.iOSAppDownload')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />{' '}
                                                    <a
                                                        href = 'https://play.google.com/store/apps/details?id=go.meethour.io'
                                                        rel = 'noopener noreferrer'
                                                        target = '_blank'>
                                                        {t('welcomepage.footer.androidAppDownload')}
                                                    </a>
                                                </li>

                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/disclaimer.html'>
                                                        {t('welcomepage.footer.disclaimer')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/privacy-policy.html'>
                                                        {t('welcomepage.footer.privacyPolicy')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/terms-conditions.html'>
                                                        {t('welcomepage.footer.termsConditions')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />
                                                    <a href = '/FAQ.html'>
                                                        {t('welcomepage.footer.faqs')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />{' '}
                                                    <a
                                                        href = 'https://docs.v-empower.com/docs/MeetHour-API '
                                                        rel = 'noreferrer'
                                                        target = { '_blank' }>
                                                        {t('welcomepage.footer.apiDocumentation')}
                                                    </a>
                                                </li>
                                                <li>
                                                    <i className = 'bx bx-chevron-right' />{' '}
                                                    <a
                                                        href = 'https://github.com/v-empower/MeetHour-Web-MobileSDKs'
                                                        rel = 'noreferrer'
                                                        target = { '_blank' }>
                                                        {t('welcomepage.footer.webMobileSDK')}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className = 'col-lg-4 col-md-6 footer-newsletter'>
                                            <img
                                                className = 'img-fluid'
                                                src = 'images/footer-img.png' />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className = 'container d-md-flex py-4'>
                                <div className = 'mr-md-auto text-center text-md-left'>
                                    <div className = 'copyright'>
                                        &copy; {t('welcomepage.footer.copyright')}{' '}
                                        <strong>
                                            <span>{t('welcomepage.footer.meethour', { lng: 'en' })}</span>
                                        </strong>
                                        . {t('welcomepage.footer.allRightsReserved')}
                                    </div>
                                </div>
                                <div className = 'social-links text-center text-md-right pt-3 pt-md-0'>
                                    <a
                                        href = 'https://www.facebook.com/meethour/'
                                        rel = 'noopener noreferrer'
                                        target = '_blank'>
                                        <i className = 'bx bxl-facebook' />
                                    </a>
                                    <a
                                        href = 'https://twitter.com/MeetHourApp/'
                                        rel = 'noopener noreferrer'
                                        target = '_blank'>
                                        <svg
                                            height = '17'
                                            style = { _inlineStyles._s1 }
                                            viewBox = '0 0 512 512'
                                            width = '17'
                                            xmlns = 'http://www.w3.org/2000/svg'>
                                            <path
                                                d = { 'M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8'
                                                    + 'L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48z'
                                                    + 'M364.4 421.8h39.1L151.1 88h-42L364.4 421.8z' }
                                                fill = '#ffffff' /></svg>
                                    </a>
                                    <a
                                        href = 'https://www.instagram.com/MeetHourApp/'
                                        rel = 'noopener noreferrer'
                                        target = '_blank'>
                                        <i className = 'bx bxl-instagram' />
                                    </a>
                                    <a
                                        href = 'https://www.linkedin.com/company/meethour/'
                                        rel = 'noopener noreferrer'
                                        target = '_blank'>
                                        <i className = 'bx bxl-linkedin' />
                                    </a>
                                    <a
                                        href = ' https://www.youtube.com/channel/UCbB-py_vQt2lXJ1VMMVIH7w/'
                                        rel = 'noopener noreferrer'
                                        target = '_blank'>
                                        <i className = 'bx bxl-youtube' />
                                    </a>
                                </div>
                            </div>
                        </>
                    )}
                    {interfaceConfig
                        && interfaceConfig?.disablePrejoinFooter && (
                        <div
                            className = 'container'
                            style = { styleWeb.disablePrejoinFooter }>
                            <h3 style = { h3Style }>
                                {interfaceConfig.APP_NAME}
                                {interfaceConfig.SHOW_POWERED_BY
                                        && <span>. Powered by Meet Hour</span>
                                }
                            </h3>
                        </div>
                    )}
                </footer>
            )}
        </React.Fragment>
    );
};
